export default __webpack_public_path__ + "static/media/page404.30a10da6.png";